import { DEFINITIONS as BOLD_DEFINITIONS } from '@xing-com/content-editor-plugin-bold';

import { BOLD_TYPENAME } from '../constants';

const DEFINITIONS = { ...BOLD_DEFINITIONS, __typename: BOLD_TYPENAME };

const boldSerializer = ({ node, matchMark, createMark }) => {
  if (
    matchMark({
      node,
      match: DEFINITIONS,
    })
  ) {
    const { start, end } = node;
    if (start === end) return;
    return createMark({
      node,
      definitions: DEFINITIONS,
    });
  }
};

export { boldSerializer };
